import {apiConstants, config, requestOptions, requestTypes, sendRequest} from "../../../../Utilities/Api";

class serverAphCatalogItemApi {

    static GetAphCatalogItemById(aphCatalogItemId: string) {
        return sendRequest(
            requestOptions(config.URL + `aph/catalog/${aphCatalogItemId}`,
                requestTypes.GET,
            ),
        );
    }

    static AddAphCatalogItem(aphCatalogItemModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(`${config.URL}aph/catalog/`,
                requestTypes.POST,
                JSON.stringify(aphCatalogItemModel),
                apiConstants.successMessage.catalog.CATALOG_ITEM_ADDED
            ),
        );
    }

    static UpdateAphCatalogItem(aphCatalogItemModel: Record<string, unknown>) {

        return sendRequest(
            requestOptions(`${config.URL}aph/catalog/`,
                requestTypes.PUT,
                JSON.stringify([aphCatalogItemModel]),
                apiConstants.successMessage.catalog.CATALOG_ITEM_UPDATED
            ),
        );
    }
}

export const aphCatalogItemApi = config.environment.MODE === config.modes.SERVER ? serverAphCatalogItemApi : serverAphCatalogItemApi;
